import React, { useState } from 'react';
import { Button } from '@storable/canaveral-components';
import HostnameCertSettingsDomainDeleteModal from '../../containers/HostnameCertSettingsDomainDeleteModal';
import styles from './styles.scss';

const HostnameCertSettingsDomainDelete = ({ ...rest }) => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  return (
    <>
      <Button
        className={styles.trash}
        context="bare"
        icon="trash"
        label="trash"
        onClick={toggleModal}
      />
      {showModal && (
        <HostnameCertSettingsDomainDeleteModal
          onDismiss={toggleModal}
          {...rest}
        />
      )}
    </>
  );
};

export default HostnameCertSettingsDomainDelete;
